import { Core } from '@springtree/eva-services-core';
import productDetailBundleState from './product-detail-bundle-state.js';
import buildServiceState from '../../builders/build-service-state.js';
import currentUserState from '../current-user/current-user-state.js';
const productDetailsAvailabilityState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productDetailBundleAvailability',
    service: Core.GetProductAvailability,
    beforeRequest: ({ req, get }) => {
        const currentBundleProduct = get(productDetailBundleState.response);
        const currentUser = get(currentUserState.response);
        if (!currentBundleProduct || !currentBundleProduct.Products?.length) {
            return;
        }
        const organizationUnitsForPickup = [];
        if (currentUser?.User?.CurrentOrganizationID) {
            organizationUnitsForPickup.push(currentUser.User.CurrentOrganizationID);
        }
        const productsInBundle = currentBundleProduct.Products.map((bundleProduct) => {
            return {
                ID: bundleProduct.ID,
                QuantityRequested: 1,
            };
        });
        const newRequest = {
            Options: {
                Bundles: {
                    IncludeBundleInformation: true,
                },
                Delivery: {
                    AvailabilityDate: true,
                },
                Pickup: {
                    AvailabilityDate: true,
                    OrganizationUnitIDs: organizationUnitsForPickup,
                },
                QuantityAvailable: true,
                ProductAvailabilityDetails: {
                    OrganizationUnitIDs: organizationUnitsForPickup,
                    ProductIDs: productsInBundle.map(product => product.ID),
                },
            },
            ...req,
            Products: productsInBundle,
        };
        return newRequest;
    },
});
export default productDetailsAvailabilityState;
//# sourceMappingURL=product-detail-bundle-availability-state.js.map